<template>
    <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" offset-x class="rounded-xl">
        <template v-slot:activator="{ on, attrs }" class="rounded-xl">
            <v-avatar size="35" v-if="$userInfo.profile && $userInfo.profile.photo"
                v-bind="attrs" v-on="on">
                <v-img :src="$userInfo.profile.photo"></v-img>
            </v-avatar>
            <v-avatar color="primary" size="35"  v-bind="attrs" v-on="on" v-else>
                <span class="white--text text-subtitle-1">{{ $userInfo.profile.initials }}</span>
            </v-avatar>
        </template>
        <Settings
            @openHelpSupportDialog="showHelpSupportDialog = true"
        ></Settings>
        <HelpDialog :showHelpDialog="showHelpSupportDialog" @closeHelpDialog="showHelpSupportDialog = false" />

    </v-menu>
</template>
<script>
import Settings from '../views/Settings.vue'
import HelpDialog from './HelpDialog.vue'
export default {
  name: 'app-bar-menu',
  components: {
    Settings,
    HelpDialog
  },
  data: () => ({
    showHelpSupportDialog: false,
    fav: true,
    menu: false,
    message: false,
    hints: true,
    settings: []

  }),
  methods: {
    toggleTheme () {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
    }
  }
}
</script>
